var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tfedu-layout"},[_c('div',{ref:"tfedu-nav-box",class:['tfedu-nav', { 'home': _vm.showBg }]},[_c('div',{staticClass:"tfedu-nav-box"},[_c('router-view',{key:_vm.$route.fullPath})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }